import React, { Component } from "react";

import StatusFilter from "./StatusFilter";
import { WO_FILTERS } from "../../../Appointments/common";
import { getPreference } from "../../../../util/preferences";

import "./StatusFilters.scss";

export const DAYPLANNER_STATUSES = {
  NEW_CAR: 1,
  CAR_CHECK: 2,
  CUSTOMER_OK: 4,
  DIAGNOSE: 6,
  ANNAME_OK: 7,
  CUSTOMER_ANSWERED: 12,
  BACK_ORDER: 13,
  HANDLE_CHECK_IN: 50,
  CAR_IN_SHOP: 52,
  PANIC: 100,
};

export const ShouldBeFiltered = (appointment, filterValue, selectedWoInternalFilter) => {
  const shouldFilterOnSelectedWoInternalFilter = selectedWoInternalFilter
    ? selectedWoInternalFilter === WO_FILTERS.ALL ||
      (appointment.internal && selectedWoInternalFilter === WO_FILTERS.INTERNAL) ||
      (!appointment.internal && selectedWoInternalFilter === WO_FILTERS.WO)
    : true;

  if (filterValue === DAYPLANNER_STATUSES.PANIC) return appointment.has_panic;

  if (filterValue === DAYPLANNER_STATUSES.CAR_IN_SHOP) {
    return appointment.appointment_status_identifier === filterValue && appointment.car_in_shop && !appointment.car_out_of_shop && shouldFilterOnSelectedWoInternalFilter;
  }

  return appointment.appointment_status_identifier === filterValue && shouldFilterOnSelectedWoInternalFilter;
};

class DayplannerStatusFilters extends Component {
  state = {
    activeFilter: getPreference("dayplanner-activeFilter", null),
    filtersCounts: Object.values(DAYPLANNER_STATUSES).reduce((arr, value) => {
      arr[value] = 0;
      return arr;
    }, []),
  };

  componentDidMount() {
    this.updateFiltersCounts();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.appointments !== this.props.appointments) {
      this.updateFiltersCounts();
    }
  }

  updateFiltersCounts = () => {
    const counts = [];

    Object.values(DAYPLANNER_STATUSES).forEach(filterValue => {
      counts[filterValue] = this.props.appointments.filter(app => {
        return ShouldBeFiltered(app, filterValue);
      }).length;
    });

    this.setState({ filtersCounts: counts });
  };

  handleClick = selectedFilter => {
    if (selectedFilter === DAYPLANNER_STATUSES.BACK_ORDER) {
      const { backorderFilterInactive, onBackorderStatusFilterClick } = this.props;

      onBackorderStatusFilterClick(!backorderFilterInactive);
    } else {
      const activeFilter = this.state.activeFilter === selectedFilter ? null : selectedFilter;

      this.setState({ activeFilter }, () => {
        this.props.onStatusFilterClick(this.state.activeFilter);
      });
    }
  };

  getColorForFilter = filterStatus => {
    switch (filterStatus) {
      case DAYPLANNER_STATUSES.NEW_CAR:
        return "#F49523";
      case DAYPLANNER_STATUSES.CAR_IN_SHOP:
        return "#EFC56B";
      case DAYPLANNER_STATUSES.PANIC:
        return "#DB2828";
      case DAYPLANNER_STATUSES.ANNAME_OK:
        return "#FF5722";
      case DAYPLANNER_STATUSES.HANDLE_CHECK_IN:
        return "#5F7D8B";
      case DAYPLANNER_STATUSES.CAR_CHECK:
        return "#F8C02B";
      case DAYPLANNER_STATUSES.DIAGNOSE:
        return "#69BEC0";
      case DAYPLANNER_STATUSES.CUSTOMER_ANSWERED:
        return "#EA2D62";
      case DAYPLANNER_STATUSES.CUSTOMER_OK:
        return "#2D85D0";
      case DAYPLANNER_STATUSES.BACK_ORDER:
        return "#6C0699";
      default:
        return "#FFFFFF";
    }
  };

  render() {
    const { activeFilter, filtersCounts } = this.state;
    const { backorderFilterInactive } = this.props;

    return (
      <div className="status-filters">
        {Object.keys(DAYPLANNER_STATUSES).map((key, index) => {
          const status = DAYPLANNER_STATUSES[key];
          const isDisabled = status === DAYPLANNER_STATUSES.BACK_ORDER ? backorderFilterInactive : activeFilter !== null && activeFilter !== status;

          return (
            <StatusFilter
              key={key}
              color={this.getColorForFilter(status)}
              name={key}
              count={filtersCounts[status]}
              filter={status}
              onClick={() => this.handleClick(status)}
              disabled={isDisabled}
            />
          );
        })}
      </div>
    );
  }
}

export default DayplannerStatusFilters;
